import React from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Avatar, Tooltip } from '@mui/material';

const CharacterImageUpload = ({ onImageUpload, character, assets }) => {
  // Use the image from the assets store or fall back to null
  const characterImage = assets.characters[character.name] || null;

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      const reader = new FileReader();
      reader.onload = () => {
        onImageUpload(character.name, reader.result); // Pass the image to the parent
      };
      reader.readAsDataURL(file);
    },
  });

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Tooltip title="Upload Image">
        <Avatar
          src={characterImage} // Use the image from assets
          sx={{ width: 56, height: 56, cursor: 'pointer' }}
          {...getRootProps()}
        >
          {!characterImage && character.name[0]} {/* Fallback to first letter if no image */}
        </Avatar>
      </Tooltip>
      <input {...getInputProps()} />
    </Box>
  );
};

export default CharacterImageUpload;